import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Close, DeleteOutline } from '@mui/icons-material';
import { FlexSpacer } from '../../../../Layout';
import { useL10n } from '@uplift/hooks';
import { Appointment } from '@uplift/api';

export const useSessionDetailsHeaderStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(1),
  },
  title: {
    color: theme.palette.darkSlate.main,
  },
  buttons: {
    display: 'flex',
    gap: theme.spacing(3),
    marginRight: theme.spacing(1),
  },
}));

export const SessionDetailsHeader: React.FC<{
  onClose: () => void;
  onCancelSession?: (appointment: Appointment) => void;
  appointment?: Appointment;
  title?: string;
}> = ({ onClose, appointment, onCancelSession, title }) => {
  const l10n = useL10n();
  const { classes } = useSessionDetailsHeaderStyles();

  return (
    <Box className={classes.root}>
      <FlexSpacer />
      {title && <Typography className={classes.title} variant="h6">{title}</Typography>}
      <FlexSpacer />

      <Box className={classes.buttons}>
        {onCancelSession && (
          <Tooltip title={l10n.sessions.cancelSession}>
            <IconButton
              size="small"
              onClick={() => {
                appointment && onCancelSession(appointment);
              }}
            >
              <DeleteOutline />
            </IconButton>
          </Tooltip>
        )}
        <IconButton size="small" onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
};
